import React from 'react'
import Header from 'components/Header'
import { Link, Redirect } from 'react-router-dom'
import DoctorListItem from 'components/consult/DoctorListItem'
import ConsultRequestButton from 'components/consult/ConsultRequestButton'
import SnackBar from 'components/SnackBar'
import Loading from 'components/Loading'
import axios from 'axios'
import utils from 'Utils'
import 'style/consult/doctors-consult-category.css'

class DoctorsConsultCategory extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            redirect: '',
            // consultCategory: (props.location.state && props.location.state.consultCategory) || {},
            consultCategory: {},
            doctors: [],
            page: 0,
            totalPage: 0,
            loadingMore: false
        }
    }

    async componentDidMount() {
        // if (!this.props.location.state || !this.props.location.state.consultCategory) await this.getConsutlCategory()
        this.setState({ loading: true })
        await this.getConsutlCategory()
        await this.apiGetDoctors(this.state.page)
        this.setState({ loading: false })
    }

    getConsutlCategory = async () => {
        this.setState({ loading: true })

        const res = await axios.get(utils.urls.consultCategoryURL(this.props.match.params.id))
            .catch((e) => {
                console.log(e.response)
                let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
                this.SnackBar.openSnackbar(message)
            })


        if (!res) return
        if (!res.data.success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

        this.setState({ consultCategory: res.data.consultCategory })
    }

    apiGetDoctors = async (page = 0) => {
        let res = await axios.get(utils.urls.doctorsUrl(this.state.consultCategory.id, page))
            .catch((e) => {
                console.log(e.response)
                let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
                this.SnackBar.openSnackbar(message)
            })

        if (!res) return
        if (!res.data.success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

        this.append(res.data)

        this.setState({ totalPage: (Math.ceil(res.data.total / 30) - 1) })
    }

    append = data => {
        let complex = {}


        data.consultRating.forEach(item => {
            complex[item.doctorId] = item
        })

        let mergedDoctor = data.doctors.map(doctor => {
            if (!complex[doctor.id]) return doctor

            return { ...doctor, rateItem: complex[doctor.id] }
        })

        this.setState({ doctors: [...this.state.doctors, ...mergedDoctor] });
    }

    handleScroll = async (event) => {
        const target = event.target

        if (target.scrollHeight - target.scrollTop > target.clientHeight - 100) {

            if (this.state.page + 1 <= this.state.totalPage) {
                this.setState({ loadingMore: true })
                await this.setState({ page: this.state.page + 1 })
                await this.apiGetDoctors(this.state.page)
                this.setState({ loadingMore: false })
            }
        }
    }

    clickOnConsultRequestButton = () => {
        console.log('tag manager', 'click on consult request button')
        utils.sendGtmEvent('Convert', 'First D Request')
        this.setState({ redirect: { pathname: '/consult/new', state: { consultCategory: this.state.consultCategory } } })
    }

    clickOnDoctorItem() {
        console.log('tag manager', 'click on doctor item')
        utils.sendGtmEvent('Convert', 'Click on Doctor')
    }

    render() {
        if (this.state.redirect) return <Redirect to={this.state.redirect} push />

        return (
            <>
                <Header showBackButton title={`دکتر های دسته بندی ${this.state.consultCategory ? this.state.consultCategory.name : ''}`} />
                <div className="page-root" onScroll={this.handleScroll}>
                    {this.state.loading ?
                        <Loading /> :
                        <>
                            <ConsultRequestButton
                                title="پرسش از اولین پزشک"
                                subTitle="پاسخ در سریع ترین زمان توسط یکی از پزشکان در دسترس"
                                onClick={this.clickOnConsultRequestButton}
                                price={this.state.consultCategory.price}
                                showIcon
                                btnText="ثبت درخواست"
                            />
                            <div className="doctors-list__title">پرسش از پزشک دلخواه</div>
                            {this.state.doctors.map(doctor =>
                                <Link key={doctor.id} to={`/doctors/${doctor.id}`} onClick={this.clickOnDoctorItem}>
                                    <DoctorListItem doctor={doctor} />
                                </Link>
                            )}
                            {this.state.loadingMore &&
                                <div>
                                    <Loading style={{ margin: '0 auto', background: 'rgba(255, 255, 255, 0)', display: 'block', width: '35px' }} />
                                </div>
                            }
                        </>
                    }
                </div>
                <SnackBar ref={el => this.SnackBar = el} />
            </>
        )
    }
}

export default DoctorsConsultCategory
